<template>
  <div class="journal">
    <!-- 操作日志 -->
    <div class="title">
      <label>操作日誌</label>
    </div>
    <div class="journal-title">
      <el-form
        :border="true"
        :inline="true"
        class="demo-form-inline"
      >
        <el-form-item>
          <el-select
            v-model="operationModule"
            placeholder="功能模塊"
            class="select"
          >
            <el-option
              v-for="item in operationModules"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="operationType">
          <el-select
            v-model="operationType"
            placeholder="操作類型"
            class="select"
          >
            <el-option
              v-for="item in operationTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="createUser">
          <el-input
            v-model="createUser"
            placeholder="輸入使用者進行搜尋"
            suffix-icon="el-icon el-icon-search"
            class="search"
          />
        </el-form-item>
        <el-form-item
          label="操作時間："
          prop="startTime"
          class="doTime"
        >
          <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="選擇日期"
            class="block"
            :picker-options="start_Date"
          />
        </el-form-item>
        <el-form-item prop="endTime">
          <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="選擇日期"
            class="block"
            :picker-options="end_Date"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="danger"
            class="search-btn"
            @click="search_action"
          >
            搜尋
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            class="reset-btn"
            @click="reset_action"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="journal-content">
      <el-table
        :data="tableData"
        tooltip-effect="dark myTooltip"
        :header-cell-style="{ background: 'rgba(80,181,255,0.15)', color: '#44444F' }"
        empty-text="暫無數據"
      >
        <el-table-column
          prop="operationModuleCulture"
          label="功能模塊"
          width="120px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="operationTypeCulture"
          label="操作類型"
          width="120px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          prop="content"
          label="操作日誌"
        >
          <!-- :show-overflow-tooltip="true" -->
          <template slot-scope="scope">
            <div class="flex-cont">
              <el-tooltip
                placement="top"
                effect="dark"
                :content="scope.row.content "
              >
                <span
                  class="row-span"
                  style="display:inline-block;"
                >{{ scope.row.content }}</span>
              </el-tooltip>
              <!-- position:absolute;top:0;right:0 -->
              <el-tooltip
                placement="top"
                effect="dark"
                :content="copyText"
              >
                <i
                  style="margin-left:10px;cursor: pointer;"
                  @click="onCopy(scope.row.content)"
                >
                  <svg
                    aria-hidden="true"
                    class="icon"
                  ><use xlink:href="#iconfuzhi" /></svg>
                </i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="createUser"
          label="使用者"
          width="180px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="操作時間"
          :show-overflow-tooltip="true"
          width="250px"
        >
          <template slot-scope="res">
            {{ res.row.createTime.split('T')[0] }}
            {{ res.row.createTime.split('T')[1] }}
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          class="page"
          background
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="count"
          @size-change="handleSizeChange"
          @current-change="currentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Journal',
    data() {
        return {
            copyText: '複製文字',
            // 总页数
            count: 0,
            // 搜索参数
            operationModule: '', //操作模块
            operationType: '', //操作类型
            createUser: '', //使用者
            startTime: new Date() - (new Date() % (24 * 60 * 60 * 1000)) - 8 * 60 * 60 * 1000, //起始时间
            endTime: new Date() - (new Date() % (24 * 60 * 60 * 1000)) - 8 * 60 * 60 * 1000 + (24 * 60 * 60 * 1000 - 1000), //终止时间
            nowDown: new Date() - (new Date() % (24 * 60 * 60 * 1000)) - 8 * 60 * 60 * 1000 + (24 * 60 * 60 * 1000 - 1000),
            nowUp: new Date() - (new Date() % (24 * 60 * 60 * 1000)) - 8 * 60 * 60 * 1000,
            pageIndex: 1, //页数
            pageCount: 10, //每页显示条数
            // 功能模块
            operationModules: [
                {
                    value: 'companyDetail',
                    label: '公司資料'
                },
                {
                    value: 'storeManage',
                    label: '分行管理'
                },
                {
                    value: 'organizationManage',
                    label: '組別管理'
                },
                {
                    value: 'staffManage',
                    label: '員工管理'
                }
            ],
            // 操作类型
            operationTypes: [
                {
                    value: 'add',
                    label: '新增'
                },
                {
                    value: 'edit',
                    label: '編輯'
                },
                {
                    value: 'delete',
                    label: '刪除'
                },
                {
                    value: 'updateStatus',
                    label: '狀態更改'
                },
                {
                    value: 'transfer',
                    label: '轉移'
                }
            ],
            // 表单数据
            tableData: [],
            // 查询条件
            searchData: '',
            // 时间限制
            end_Date: {
                disabledDate: time => {
                    if (this.startTime) {
                        return time < new Date(Number(this.nowUp) - 24 * 60 * 60 * 1000 * 30) || time < this.startTime;
                    } 
                        return time < new Date(Number(this.nowUp) - 24 * 60 * 60 * 1000 * 30);
                    
                }
            },
            start_Date: {
                disabledDate: time => {
                    if (this.endTime) {
                        return time < new Date(Number(this.nowUp) - 24 * 60 * 60 * 1000 * 30) || time > this.endTime;
                    } 
                        return time < new Date(Number(this.nowUp) - 24 * 60 * 60 * 1000 * 30);
                    
                }
            }
        };
    },
    created() {
        this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'journalPageCount') || 10;
        this.getTableData();
    },
    methods: {
        onCopy(data) {
            navigator.clipboard.writeText(data).then(() => {
                this.$message.success('複製成功')
            })
        },
        // 获取搜索参数
        getSearchData() {
            return {
                operationModule: this.operationModule,
                operationType: this.operationType,
                createUser: this.createUser,
                pageIndex: this.pageIndex,
                pageCount: this.pageCount,
                startTime: this.startTime ? Number(this.startTime) / 1000 : '',
                endTime: this.endTime === this.nowDown ? this.endTime / 1000 : Number(this.endTime) / 1000 + (24 * 60 * 60 - 1)
            };
        },
        // 查询功能
        search_action() {
            if (this.startTime === null || this.endTime === null) {
                this.$message({
                    showClose: true,
                    message: '請選擇搜尋時間',
                    type: 'error'
                });
            } else {
                this.pageIndex = 1;
                let searchData = this.getSearchData();
                this.getTableData(searchData);
                this.$message({
                    showClose: true,
                    message: '搜尋成功',
                    type: 'success'
                });
            }
        },
        reset_action() {
            // 将逗号改为分号，并分行书写
            this.operationModule = '';
            this.operationType = '';
            this.createUser = '';
            
            const todayStart = new Date(new Date().toLocaleDateString()).getTime();
            this.startTime = todayStart;
            this.endTime = todayStart + (24 * 60 * 60 * 1000 - 1000);

            this.getTableData();
        },
        // 重置功能
        // reset_action() {
        //     (this.operationModule = ''), (this.operationType = ''), (this.createUser = ''), (this.startTime = new Date(new Date().toLocaleDateString()).getTime()), (this.endTime = new Date(new Date().toLocaleDateString()).getTime() + (24 * 60 * 60 * 1000 - 1000));
        //     this.getTableData();
        // },
        // 分页功能
        currentChange(pageIndex) {
            this.pageIndex = pageIndex;
            // this.searchData = this.getSearchData()
            this.getTableData();
        },
        // 获取当前每页显示数量
        handleSizeChange(pageCount) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID,'journalPageCount',pageCount)
            this.pageCount = pageCount;
            this.getTableData();
        },

        // 列表数据渲染
        async getTableData() {
            let { data } = await this.axios.post(this.pub.getApi().SearchOperationLog, this.getSearchData());
            let result = data.result;
            if (data.code === 0) {
                this.count = data.result.count;
                this.tableData = data.result.data;
            }
        }
    }
};
</script>
<style lang="less">
@import '../../assets/css/element-reset.less';

.journal {
    text-align: left;
    padding: 20px;
    .el-input--suffix .el-input__inner {
        padding-right: 15px;
    }
    // .journal .journal-content tr {
    //   border-bottom: 1px solid red;
    // }
    .title {
        margin: 0 40px 10px 0;
        font-size: 24px;
        padding-bottom: 20px;
    }
    .search-btn {
        background-color: #e50113;
        border: none;
        width: 88px;
        margin-left: 10px;
    }
    .reset-btn {
        background-color: #bbbbbb;
        border: none;
        color: #ffffff;
        width: 88px;
    }
    .el-form-item {
        margin-right: 15px;
    }
    .el-form-item__label {
        padding-right: 5px;
        color: #666 !important;
    }
    .journal-title {
        padding-bottom: 20px;
        .el-input__inner,
        .el-button {
            border-radius: 10px;
        }
        .el-select {
            height: 38px;
        }
        .select {
            // margin-right: 15px;

            width: 120px;
        }
        .search {
            // margin-right: 15px;
            width: 175px;
        }
        .block {
            width: 140px;
            height: 25px;
        }
    }
    .journal-content {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 20px;
        padding: 20px;
        box-sizing: border-box;
        color: #44444f;
        font-size: 14px;
        // tr,
        // td,
        // th {
        //   // border: none;
        // }
        .row-span{
            width:85%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .el-table::before {
            height: 0;
        }
        .footer {
            span {
                font-size: 14px;
                color: #44444f;

                margin-left: 16px;
            }
            margin-top: 16px;
            // border-top: 1px solid #e2e2ea;
            padding-top: 20px;
            box-sizing: border-box;
            height: 72px;
            .page {
                float: right;
            }
            .input-number {
                text-align: left;
                float: right;
                width: 70px;
            }
            /**覆盖计数器样式 */
            // .el-input-number.is-controls-right .el-input__inner {
            //   padding-left: 8px;
            //   padding-right: 42px;
            // }
        }
        .flex-cont{
            display: flex;
            flex-direction: row;
            justify-content: space-around;
        }
    }
}
</style>
